import React, { useState } from "react";
import JobCard from "./JobCard";
import SpecialismFilter from "./SpecialismFilter";
import "./JobListPage.css";
import { useNavigate } from "react-router-dom";

const jobsData = [
    {
        id: "1",
        title: "Life Insurance Actuary",
        salary: "Negotiable",
        location: "Accra",
        type: "Permanent",
        specialism: "Life Insurance",
        postedDate: "04/17/2025",
        summary: "This role is for a seasoned Life Insurance Actuary reporting to the Managing Director, responsible for leading actuarial functions including IFRS 17 reporting, product pricing, financial reporting, and risk management. The position involves guiding strategic decisions, ensuring regulatory compliance, overseeing reinsurance and solvency assessments, and delivering actuarial insights for business growth. It requires 15–20 years of experience, with a strong background in life insurance, financial reporting, and team leadership",
        responsibilities: [
          {
            main: "Carry out actuarial tasks such as:",
            sub: [
              "Internal and regulatory reporting based on IFRS 17 Standards",
              "Providing direction on IFRS 17 methodologies, systems, and processes",
              "Assessing the quality of data used for technical provisions",
              "Comparing best estimates against actual experience",
              "Informing the Board of the reliability and adequacy of the calculation of technical provisions",
              "Expressing an opinion on the overall underwriting policy.",
              "Assessing the adequacy of reinsurance arrangements",
              "Contributing to the effective implementation of the risk-management strategy."
            ]
          },
          {main: "Lead product development and pricing of products"},
          {main: "Lead the development of the Financial Condition Report"},
          {main: "Responsible for determining the new business profit for reporting and pricing decisions."},
          {main: "Participate in strategy development as may be assigned and implement the actuarial and risk management components of the strategy to facilitate the wider business strategy."},
          {main: "Lead actuarial services related to reserving and financial reporting, new business reporting and actuarial planning activity; develop actuarial reporting standards and controls to be applied consistently to ensure robust actuarial data is provided for business decision-making purposes."},
          {main: "Responsible for providing actuarial input and recommendations to management for business decision making and advising management of the actuarial and business implications of certain strategies locally, the risks involved and potential risk management/mitigation options available."},
          {main: "Review analysis of experience trends and expenses, initiating action where necessary; recommend further analyses and investigations."},
          {main: "Responsible for reinsurance arrangement with Reinsurers."},
          {main: "Assist in calculating the company’s current and future solvency positions, calculating the interest rate to be applied to savings plans, asset liability management."},
        ],
        requirements: [
          { main: "Qusalified or Nearly Qualified Actuary (from a recognized professional actuarial body) with proven experience in the life insurance business and enterprise risk management." },
          { main: "Financial reporting experience." },
          { main: "Strong analytical, problem solving and modelling skills." },
          { main: "Proven track record in delivering key objectives, with a demonstrated ability in managing multiple tasks." },
          { main: "Ability to effectively lead, develop and motivate your team to ensure delivery against objectives and maximising potential." },
          { main: "15-20 years of progressive experience in a corporate actuarial environment, with at least 10 years in a senior leadership role." },
        ]
      }, 
];

const specialisms = [
  { name: "Life Insurance", count: 1 },
  { name: "Pensions", count: 0 },
  { name: "General Insurance", count: 0 },
  { name: "Health Insurance", count: 0 },
  { name: "Finance & Investments", count: 0 },
  { name: "Consulting", count: 0 },
  { name: "Data Science", count: 0 },
  { name: "Teaching & Research", count: 0 },
  { name: "Insurtech & Systems", count: 0 },
  { name: "Others", count: 0 },
];

const JobListPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSpecialisms, setSelectedSpecialisms] = useState([]);
  const navigate = useNavigate();

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleSpecialismChange = (specialism) => {
    setSelectedSpecialisms((prev) =>
      prev.includes(specialism)
        ? prev.filter((item) => item !== specialism)
        : [...prev, specialism]
    );
  };

  const filteredJobs = jobsData.filter((job) => {
    const matchesSearch = job.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesSpecialism =
      selectedSpecialisms.length === 0 || selectedSpecialisms.includes(job.specialism);
    return matchesSearch && matchesSpecialism;
  });

  return (
    <div>
        <section className="section-aboutasg">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">ACTUARIAL JOBS</h2>
      <div className="sectionbottom-line"></div>
      </section>
    <div className="job-list-page">


      <div className="job-list-container">
        <aside className="sidebar">
          <h2 className="specialism-section-title">Specialism Search</h2>
          <SpecialismFilter
            specialisms={specialisms}
            selected={selectedSpecialisms}
            onChange={handleSpecialismChange}
          />
        </aside>

        <main className="main-content">
          <input
            className="search-bar"
            type="text"
            placeholder="Search jobs..."
            value={searchTerm}
            onChange={handleSearchChange}
          />

          {filteredJobs.map((job) => (
            <JobCard
            key={job.id}
            job={job}
            onClick={() => navigate(`/jobs/${job.id}`, { state: { job } })}
          />          
          ))}
        </main>
      </div>
    </div>
    </div>
  );
};

export default JobListPage;
